import React from 'react';
import cn from 'classnames';

import Card from '../Card';
import Text from '../Text';
import Share from '../Share';

import * as styles from './Playlist.module.css';
import * as textStyles from '../../styles/text.module.css';

const Playlist = ({
  headline,
  byLine,
  intro = '',
  spotifyUrl = '',
  id,
  slug

}) => {
  
  let playlistId;
  try {
    const url =  new URL(spotifyUrl);
    playlistId = url.pathname.split('/').pop();
  } catch (err) {
    console.error('Empty Spotify url');
  }
  
  return (
    <Card id={id} className={cn(styles.root)} title="Un playlist" animate>
      <h3 className={cn(textStyles.headline, styles.headline)}>{headline}</h3>
      <div className={cn(styles.info)}>
        <div className={cn(styles.byLine)}>
          <p className={styles.name}>Por {byLine.name}</p>
          <p>
            {byLine.role}
            {byLine.role && byLine.company && ', '}
            {byLine.company}
          </p>
        </div>
      </div>
      <div className={styles.columns}>
        <Text className={cn(textStyles.body, styles.intro)} text={intro} />
        <div className={cn(styles.playerWrapper)}>
          {playlistId && <iframe
            title="Refracciones Playlist"
            className={cn(styles.player)}
            src={`https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`}
            width="100%"
            height="380"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>}
        </div>
      </div>
      <Share
        alignTo="right"
        url={`${slug}#${id}`}
        className={cn(styles.share)}
      />
    </Card>
  );
};

export default Playlist;
